<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs pos-relative">
  <div class="cards-holder devices-tab">
    <div class="card card2 mRight sem-creative-card-v3 devices-carousel creative-performance-stats display-creative-container">
      <app-loader [showLoader]=showLoad></app-loader>
      <div *ngIf="hasData">
        <ngu-carousel #carousel [inputs]="carouselOne" (carouselLoad)="initDataFn($event)" [dataSource]="creatives">
          <span NguCarouselPrev class="leftRs">
            <i class="fa fa-angle-left" aria-hidden="true"></i>
          </span>
          <span NguCarouselNext class="rightRs">
            <i class="fa fa-angle-right" aria-hidden="true"></i>
          </span>
          <ngu-tile *nguCarouselDef="let creative;" NguCarouselItem>
            <div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom">
              <div class="o-stack__cell portlet-subheader-wrapper">
                <h5 *ngIf="semCreativeCard" class="sem-creative-headline">{{(creative && creative.ad_headline)?creative.ad_headline:''}}</h5>
              </div>
            </div>
            <div class="c-portlet__content u-pt-small" class="sem-creative-item">
              <div class="sem-creative-card-container height-100p">
                <div *ngIf="creative && hasData" class="height-100p">
                  <div class="sem-creative-card" [ngStyle]="{'padding-top': dotsHeight}">
                    <div class="sem-creative-heading">{{creative.ad_headline}}</div>
                    <div class="sem-creative-card-link-container">
                      <span class="sem-creative-card-text">AD</span>
                      <cite class="sem-creative-card-link">{{creative.url}}</cite>
                    </div>
                    <span class="sem-creative-card-roboto"> {{creative.callExtension}}</span>
                    <div *ngIf="isTypeString(creative?.description); else elseBlock" class="sem-creative-card-description sem-creative-card-roboto">
                      {{creative?.description}}
                  </div>
                  <ng-template #elseBlock>
                      <div class="sem-creative-card-description sem-creative-card-roboto">
                          <p *ngFor="let desc of creative?.description">
                            {{desc}}
                          </p>
                      </div>
                  </ng-template>
                   
                    <div class="sem-creative-card-callouts-container sem-creative-card-roboto">
                      <div>
                        <p>
                          <span *ngFor="let callout of creative?.calloutsExtn; let i=index">{{callout}}<span [ngClass]="{'last_callout_class': i==creative?.calloutsExtn.length-1}">  &middot; </span></span>
                        </p>
                      </div>
                    </div>
                      <div class="sem-creative-card-structuredsnippets-container sem-creative-card-roboto">
                        <div *ngFor="let snippet of creative?.structuredSnippetExtn">
                          <p>{{snippet?.type}}: {{snippet?.value}}</p>
                        </div>
                      </div>
                    <div class="sem-creative-card-siteLinks-container">
                      <div *ngFor="let siteLink of creative.siteLinks;" class="sem-creative-card-sitelinks">
                        <h4>
                          <a href="{{siteLink.link}}" target="_blank">{{siteLink.heading}}</a>
                        </h4>
                        <span class="sem-creative-card-roboto">{{siteLink.description}}</span>
                      </div>
                    </div>
                    <div *ngIf="creative.location.trim().split(',').length>1">
                      <span [ngStyle]="{'color' :  !last ?  '#1a0dab' : '#4a4a4a'}" *ngFor="let location of creative.location.split(','); let last = last; let first = first;" class="sem-creative-card-location"><i
                          class="fa fa-map-marker" aria-hidden="true" *ngIf="first" style="color: #575757;"></i> {{location}}<span *ngIf="!last">,</span></span>
                    </div>
                    <div class="display-carousel-table-container text-table">
                      <ul class="creative-stats">
                        <li>
                          <span class="stats">{{creative.impressions | number}}</span>
                          <span class="stats-label">Impressions</span>
                        </li>
                        <li>
                          <span class="stats">{{creative.clicks | number}}</span>
                          <span class="stats-label">Clicks</span>
                        </li>
                        <li>
                          <span class="stats">{{creative.clickthroughrate | number}}%</span>
                          <span class="stats-label">CTR</span>
                        </li>
                        <li *ngIf="!isGoliveNotStarted">
                            <span class="stats">{{creative.absTopImpressionShare | number}}%</span>
                            <span class="stats-label">Abs. Top Imp.</span>
                          </li>
                          <li *ngIf="!isGoliveNotStarted">
                            <span class="stats">{{creative.topImpressionShare | number}}%</span>
                            <span class="stats-label">Top Imp.</span>
                          </li>
                        <li *ngIf="!isCutoffDate">
                          <span class="stats">{{creative.avg_position? (creative.avg_position | number): '--'}}</span>
                          <span class="stats-label">Avg. Position</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </ngu-tile>
        </ngu-carousel>
      </div>
      <div class="no-data-container" *ngIf="!hasData">
        <div class="map-no-data">No Data to Display</div>
      </div>
    </div>
    <div class="card card2 mLeft sem-adds">
      <app-datatable [sectiontitle]="sectiontitle" [datatableconfig]="datatableconfig" [key]="key"  [isClickable]="true"
        (moveToSlide)="scrollToSlide($event)" [isVerticalScrollable]="true" [rowHeight]="60"></app-datatable>
    </div>
  </div>
</div>
